import type {
  IGetDeliveryPointsRequest,
  IMarketCustomerResponse,
  IPvzResponse,
  IZoneCoverageInfoResponse,
} from './models';

import { MMGatewayClient } from '../MMGatewayClient';

class _MMCoreBffClient extends MMGatewayClient {
  public async getMarketCustomer(): Promise<IMarketCustomerResponse> {
    return await this.get('market/v1/auth/marketCustomer');
  }

  public async getPVZByCoordAndCart(data: IGetDeliveryPointsRequest) {
    return this.post<IPvzResponse, IGetDeliveryPointsRequest>('market/v1/shops/pvzs', data);
  }

  public checkZoneByCoord(latitude: number, longitude: number) {
    return this.get<IZoneCoverageInfoResponse>(
      `market/v1/zone-by-coordinates?x=${latitude}&y=${longitude}`
    );
  }
}

export const MMCoreBffClient = new _MMCoreBffClient();
